/* eslint-disable react/jsx-no-undef */
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TopLogo from '../../components/layout/TopLogo';
import { SearchPrizeLuckyDraw } from "../../services/LuckyDraw";
import SecondaryButton from "../../components/button/SecondaryButton";
import SecondaryButtonSmall from "../../components/button/SecondaryButtonSmall";
import arrow from "../../assets/images/icon/arrow-right.svg";
import { useSelector } from 'react-redux';
import arrowLeft from "../../assets/images/icon/arrow-left.png";

export default function LuckyDrawResult() {

    const store = useSelector((state) => state.luckyDraw)

    const [prizeResult, setPrizeResult] = React.useState([]);
    
    const [windowDimensions, setWindowDimensions] = React.useState(
        getWindowDimensions()
    );
    const { state } = useLocation();
    const { width } = windowDimensions;
    const navigate = useNavigate();

    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return {
            width,
            height,
        };
    }

    React.useEffect(() => {
        getSearchPrizeLuckyDraw()
    }, []);

    async function getSearchPrizeLuckyDraw() {
        let payload = {
            memberId: store['memberId'],
            luckyDrawId: store['campaignId'],
            limit: 100,
            offset: 0,
        }
        return await SearchPrizeLuckyDraw({
            data: payload
        })
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    let data = response.data.body.rewards
                    setPrizeResult(data)
                } else {
                    setPrizeResult([])
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }


    React.useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    });



    return (
        <>
            <TopLogo />
            <div
                style={{
                    background: "#005AAA",
                    minHeight: "calc(100vh - 60px)",
                    paddingTop: "20px"
                }}
            >
                <div className="flex justify-between w-fit mx-auto">
                    <img
                        onClick={() => navigate(-1)}
                        className="mr-[5px] mt-[7px] w-[20px] h-[20px]"
                        src={arrowLeft}
                        alt="logo"
                    />
                    <div className="text-white text-[24px]">
                        ประกาศผล
                    </div>
                </div>

                <div className="overflow-y-auto px-[20px]" style={{ height: "calc(100vh - 250px)" }}>
                    {/* <InfiniteScroll
                        loadMore={fetchItems}
                        hasMore={isLoading}
                        loader={loader}
                    > */}
                    {Array.isArray(prizeResult) && prizeResult.map(item => (
                        <div className="">
                            <div id="section1" className="px-[10px] py-[15px] bg-lightGray2 mb-[20px] rounded-[6px]">
                                <div className="flex justify-between ">

                                    <p className="text-darkGray text-[20px] leading-[19.2px] px-[16px]">{store['campaignName']}</p>
                                    <p className="text-blue text-[20px] leading-[19.2px] w-[110px] text-right">จำนวน {store['campaignUsed']} สิทธิ์</p>

                                </div>
                                <div className="flex justify-between mt-[15px]">
                                    <p className="text-blue font-bold text-[24px] px-[16px]">คุณคือผู้โชคดี</p>
                                    <SecondaryButtonSmall variant="outlined" className="icon-next" style={{ minWidth: "100px" }}
                                        onClick={() => navigate('/lucky-draw-result-detail', {
                                            state: {
                                                campaignName: store['campaignName'],
                                                campaignUsed: store['campaignUsed'],
                                                prizeId: item.prizeId,
                                                name: item.name,
                                                qty: item.qty
                                            }
                                        })}
                                    >
                                        <p>ยืนยันตัวตน</p>
                                        <img className="w-[5px]" src={arrow} alt="" />
                                    </SecondaryButtonSmall>

                                </div>

                            </div>
                        </div>

                    ))}
                    {/* </InfiniteScroll> */}
                    {/* <hr className="border-b-1px border-lightGray w-full" /> */}
                    {/* <p className='py-[4px] text-center text-blue cursor-pointer' onClick={() => onLoadMore('event')}>โหลดเพิ่ม</p> */}
                </div>
            </div>
            <div className="bg-white w-full" style={{
                position: 'fixed',
                bottom: 0,
                padding: '20px'
            }}>
                <div className="place-content-center">
                    <SecondaryButton
                        fullWidth
                        variant="outlined"
                        onClick={() => navigate(-1)}
                    >
                        <p>ย้อนกลับ</p>
                    </SecondaryButton>
                </div>

            </div>
        </>
    );
}
